import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppWidget = () => {
  return (
    <div className="fixed bottom-6 right-6 z-[100]">
      <motion.a
        href="https://go.digitalgigs.eu/chat"
        target="_blank"
        rel="noopener noreferrer"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className="group relative w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center text-white shadow-2xl transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-[#25D366]/30"
        aria-label="Chat on WhatsApp"
      >
        {/* Pulse Animation */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20 group-hover:opacity-40"></span>
        
        {/* Notification Badge */}
        <span className="absolute -top-1 -right-1 flex h-5 w-5 z-10">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-5 w-5 bg-red-500 border-2 border-white flex items-center justify-center text-[10px] font-black">1</span>
        </span>

        {/* WhatsApp Icon */}
        <FaWhatsapp className="text-3xl relative z-10" />

        {/* Tooltip */}
        <div className="absolute right-full mr-4 px-4 py-2 bg-slate-900 text-white text-sm font-bold rounded-xl whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none shadow-xl">
          Chat with me now
          <div className="absolute top-1/2 -right-1 -translate-y-1/2 border-8 border-transparent border-l-slate-900"></div>
        </div>
      </motion.a>
    </div>
  );
};

export default WhatsAppWidget;
